import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { imgTema6 } from '../../../assets/tema6';
import { QuestionCardV3 } from '../../../components/common/QuestionCardV3';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	questions: 3,
	win: 4,
	fail: 5,
};

const stepThree = {

}

const gameQuestion = [
	{
		id: 1,
		question: "¿Cuánto se cobra por pagar el servicio en nuestras Tiendas OXXO?",
		img: imgTema6.QuestionCard1,
		options: [
			{
				id: 1,
				text: "$9 pesos",
			},
			{
				id: 2,
				text: "$8 pesos",
			},
			{
				id: 3,
				text: "$10 pesos",
				isCorrect: true
			},
		]
	},
	{
		id: 2,
		question: "Las comisiones de los servicios constantemente cambian.",
		img: imgTema6.QuestionCard1,
		options: [
			{
				id: 1,
				text: "Verdadero",
				isCorrect: true,
			},
			{
				id: 2,
				text: "Falso",
			},
		]
	},
	{
		id: 3,
		question: "¿Qué tecla debemos presionar para entrar a la pantalla de tiempo aire?",
		img: imgTema6.QuestionCard2,
		options: [
			{
				id: 1,
				text: "A",
				isCorrect: true,
			},
			{
				id: 2,
				text: "T",
			},
			{
				id: 3,
				text: "P",
			},
		]
	},
	{
		id: 4,
		question: "NO debes verificar el número con el Cliente después de colocarlo.",
		img: imgTema6.QuestionCard1,
		options: [
			{
				id: 1,
				text: "Verdadero",
			},
			{
				id: 2,
				text: "Falso",
				isCorrect: true,
			},
		]
	},
	{
		id: 5,
		question: "Debes verificar la información del Cliente al momento de realizar el pago de servicios.",
		img: imgTema6.QuestionCard3,
		options: [
			{
				id: 1,
				text: "Verdadero",
				isCorrect: true,
			},
			{
				id: 2,
				text: "Falso",
			},
		]
	},
]
let pointsAcumulated = 0


export const Theme6SubtopicTwoActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema2], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 2 act 2");
			ObserverEmitter.emit(EVENTS.tema6.topic2.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub02.sub2_act3_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic2.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: ""
			},
			{
				id: 3,
				text: ""
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {
		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);

		// console.log(updatedResponse);
		pointsAcumulated = updatedResponse * 10

		if (numberQuestion >= gameQuestion.length - 1) {
			if (updatedResponse >= 2) {
				ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_desk");
				setUiToShow(steps.win);
			} else {
				ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_desk");
				setUiToShow(steps.fail);
			}
			return;
		}
		setNumberQuestion(numberQuestion + 1);
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic2.initScene, 3);
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Ejercicio: Preguntas." />
					<DialogBarNew
						dialog={`¡Lo has hecho muy bien! Es momento de medir lo aprendido, contesta las siguientes preguntas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Tiempo Aire Electrónico (TAE)"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_1.sub1_act1_a02T3)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							ObserverEmitter.emit(EVENTS.tema6.topic2.actScene, "move_client");
							setUiToShow(steps.questions);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.questions && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<QuestionCardV3 data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsAcumulated}
						dialogModal="Lo has hecho excelente, prosigamos con nuestros temas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema6.activities.subtema2
								})
							);
							navigator("/home6/tema6/subtema2/activityresult");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsAcumulated}
						dialogModal="¡Tu puedes! recuerda repasar los temas para reforzar tu conocimiento."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema6.activities.subtema2
								})
							);
							navigator("/home6/tema6/subtema2/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}